<template>
  <div class="tournament-content-tab tab-categories" v-bind:class="{'tournament-content-active-tab':activeTab == 7}">

    <!-- Шапка -->
    <section class="adm-panel adm-head">
      <h3 class="adm-title">Категорії <span class="adm-count">{{filteredCategories.length}}</span></h3>
      <div class="ct-head-stats" v-if="allProtocols.length">
        <span class="adm-chip"><tkd-icon name="team"/> {{ totalSportsmans }} учасників</span>
        <span class="adm-chip warn" v-if="emptyCount > 0">порожніх: {{ emptyCount }}</span>
      </div>
      <button type="button" class="adm-btn adm-btn-primary" @click="toogleAddCategory()">
        <span aria-hidden="true"><tkd-icon name="plus"/></span> Додати
      </button>
    </section>

    <modal name="category-form-modal" classes="v--modal adm-modal" :adaptive=true :minHeight=350 height="auto" :minWidth=320 width="92%" :maxWidth=880 :scrollable=true>
      <form-category :formAddCategory="formCategoryData"></form-category>
    </modal>

<!--          <tournament-category-list-->
<!--            :categories="allProtocols"-->
<!--            title="Всі категорії"-->
<!--            list-id="category_list_categories"-->
<!--            :selected-id="selectedCategoryId"-->
<!--            wrapper-columns="1fr 1fr"-->
<!--            list-columns="minmax(0, 1fr)"-->
<!--            @item-click="updateOneCategory">-->
<!--            <template slot="item-footer" slot-scope="slotProps">-->
<!--              <div v-if="slotProps && slotProps.item">-->
<!--                <div class="category-card-meta">-->
<!--                  <span>{{ slotProps.item.age_category }}</span>-->
<!--                  <span v-if="slotProps.item.sex == 1">чоловік</span>-->
<!--                  <span v-else-if="slotProps.item.sex == 2">жінка</span>-->
<!--                </div>-->
<!--                <div class="category-card-tags">-->
<!--                  <button v-if="slotProps.item.type == 1" class="btn btn-xs btn-danger btn-fill" @click.stop>керугі</button>-->
<!--                  <button v-if="slotProps.item.type == 2" class="btn btn-xs btn-fill" style="background: #9368e9" @click.stop>пумсе</button>-->
<!--                  <button v-if="slotProps.item.show_type == 1" class="btn btn-xs btn-warning btn-outline" @click.stop>сітка</button>-->
<!--                  <button v-if="slotProps.item.show_type == 2" class="btn btn-xs btn-outline" @click.stop>список</button>-->
<!--                  <button v-if="slotProps.item.type == 2 && (slotProps.item.poomsae_type == 1 || slotProps.item.poomsae_type == 2)"-->
<!--                          class="btn btn-xs btn-outline"-->
<!--                          @click.stop>-->
<!--                    {{slotProps.item.type == 2 && slotProps.item.poomsae_type == 1 ? 'традиційне' : ''}}{{slotProps.item.type == 2 && slotProps.item.poomsae_type == 2 ? 'вільне' : ''}}-->
<!--                  </button>-->
<!--                </div>-->
<!--                <div class="category-card-actions">-->
<!--                  <button @click.stop="downloadPdf(slotProps.item, 'results')"-->
<!--                          class="btn btn-xs btn-dark btn-fill">-->
<!--                    <i class="nc-icon nc-attach-87" style="vertical-align: sub;"></i> Жеребкування (PDF)-->
<!--                  </button>-->
<!--                  <button @click.stop="downloadPdf(slotProps.item, 'weight')"-->
<!--                          class="btn btn-xs btn-dark btn-fill">-->
<!--                    <i class="nc-icon nc-attach-87" style="vertical-align: sub;"></i> Протокол зважування (PDF)-->
<!--                  </button>-->
<!--                </div>-->
<!--                <div class="category-card-actions">-->
<!--                  <button class="btn btn-xs btn-warning btn-fill" @click.stop="updateOneCategory(slotProps.item)">-->
<!--                    <i class="nc-icon nc-simple-remove" style="vertical-align: sub;"></i> Редагувати-->
<!--                  </button>-->
<!--                  <button class="btn btn-xs btn-danger btn-fill" @click.stop="deleteOneCategory(slotProps.item.id)">-->
<!--                    <i class="nc-icon nc-simple-remove" style="vertical-align: sub;"></i> Видалити-->
<!--                  </button>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div v-else class="category-item-extra">-->
<!--                <div class="category-card-meta">-->
<!--                  <span>{{ item.age_category }}</span>-->
<!--                  <span v-if="item.sex == 1">чоловік</span>-->
<!--                  <span v-else-if="item.sex == 2">жінка</span>-->
<!--                </div>-->
<!--                <div class="category-card-tags">-->
<!--                  <button v-if="item.type == 1" class="btn btn-xs btn-danger btn-fill" @click.stop>керугі</button>-->
<!--                  <button v-if="item.type == 2" class="btn btn-xs btn-fill" style="background: #9368e9" @click.stop>пумсе</button>-->
<!--                  <button v-if="item.show_type == 1" class="btn btn-xs btn-warning btn-outline" @click.stop>сітка</button>-->
<!--                  <button v-if="item.show_type == 2" class="btn btn-xs btn-outline" @click.stop>список</button>-->
<!--                  <button v-if="item.type == 2 && (item.poomsae_type == 1 || item.poomsae_type == 2)"-->
<!--                          class="btn btn-xs btn-outline"-->
<!--                          @click.stop>-->
<!--                    {{item.type == 2 && item.poomsae_type == 1 ? 'традиційне' : ''}}{{item.type == 2 && item.poomsae_type == 2 ? 'вільне' : ''}}-->
<!--                  </button>-->
<!--                </div>-->
<!--                <div class="category-card-actions">-->
<!--                  <button @click.stop="downloadPdf(item, 'results')"-->
<!--                          class="btn btn-xs btn-dark btn-fill">-->
<!--                    <i class="nc-icon nc-attach-87" style="vertical-align: sub;"></i> Жеребкування (PDF)-->
<!--                  </button>-->
<!--                  <button @click.stop="downloadPdf(item, 'weight')"-->
<!--                          class="btn btn-xs btn-dark btn-fill">-->
<!--                    <i class="nc-icon nc-attach-87" style="vertical-align: sub;"></i> Протокол зважування (PDF)-->
<!--                  </button>-->
<!--                </div>-->
<!--                <div class="category-card-actions">-->
<!--                  <button class="btn btn-xs btn-warning btn-fill" @click.stop="updateOneCategory(item)">-->
<!--                    <i class="nc-icon nc-simple-remove" style="vertical-align: sub;"></i> Редагувати-->
<!--                  </button>-->
<!--                  <button class="btn btn-xs btn-danger btn-fill" @click.stop="deleteOneCategory(item.id)">-->
<!--                    <i class="nc-icon nc-simple-remove" style="vertical-align: sub;"></i> Видалити-->
<!--                  </button>-->
<!--                </div>-->
<!--              </div>-->
<!--            </template>-->
<!--          </tournament-category-list>-->

<!--          <hr>-->

    <!-- Фільтри -->
    <section class="adm-panel category-filters">
      <div class="adm-filter-grid">
        <div class="adm-field">
          <label class="adm-label" for="ct-search">Пошук</label>
          <input id="ct-search" v-model="searchQuery"
                 type="search"
                 class="adm-input"
                 placeholder="Назва, вік, стать, тип..." />
        </div>
        <div class="adm-field">
          <label class="adm-label">Клас</label>
          <v-select label="name" :filterable="true" :options="filterClassOptions"
                    v-model="filterClassVal" >
            <template slot="no-options">Укажіть клас
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                <span class="name-city">{{ option.name }}</span>
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                <span class="name-city">{{ option.name }}</span>
              </div>
            </template>
          </v-select>
        </div>
        <div class="adm-field">
          <label class="adm-label">Тип пумсе</label>
          <v-select label="name" :filterable="true" :options="filterPoomsaeTypeOptions"
                    v-model="filterPoomsaeTypeVal" >
            <template slot="no-options">Укажіть тип пумсе
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                <span class="name-city">{{ option.name }}</span>
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                <span class="name-city">{{ option.name }}</span>
              </div>
            </template>
          </v-select>
        </div>
      </div>

      <div class="ct-filter-bar">
        <div class="adm-segmented" role="tablist" aria-label="Наповненість категорій">
          <button type="button" v-for="s in fillTabs" :key="s.id"
                  :class="{active: filterFill === s.id}" :aria-selected="filterFill === s.id"
                  @click="filterFill = s.id">
            {{ s.label }} <span class="adm-seg-count">{{ s.count }}</span>
          </button>
        </div>
        <button type="button" class="adm-btn adm-btn-sm adm-btn-ghost" v-if="hasActiveFilters" @click="resetFilters()">
          Скинути фільтри
        </button>
      </div>
    </section>

    <!-- Таблиця -->
    <section class="adm-panel adm-table-panel" v-if="visibleCategories.length > 0">
      <div class="adm-table-meta">
        <span>Показано <b>{{ visibleCategories.length }}</b> з {{ allProtocols.length }}</span>
      </div>
      <div class="adm-table-wrap">
        <table class="adm-table">
          <thead>
          <slot name="columns">
            <tr>
              <th class="col-num">№</th>
              <th class="col-id">ID</th>
              <th>Назва</th>
              <th>Вікова категорія</th>
              <th>Стать</th>
              <th class="col-count">Учасники</th>
              <!--                        <th>Кваліфікація</th>-->
              <!--                        <th>Тренер</th>-->
              <!--                        <th>Бере участь</th>-->
              <th>Документи</th>
              <th class="col-actions">Дії</th>
            </tr>
          </slot>
          </thead>
          <tbody>
          <tr v-for="(item, index) in visibleCategories" :key="item.id || index" :class="{'empty-category': !(item.count > 0)}">
            <td class="col-num">{{index+1}}</td>
            <td class="col-id">#{{item.id}}</td>
            <td class="col-name">
              <div class="ct-name">{{item.fullname}}<span class="adm-chip danger" v-if="!item.fullname">не вказано</span></div>
              <div class="ct-tags">
                <span v-if="item.type == 1" class="adm-chip strong">керугі</span><span v-if="item.type == 2" class="adm-chip strong">пумсе</span>
                <span v-if="item.show_type == 1" class="adm-chip">сітка</span>
                <span v-if="item.show_type == 2" class="adm-chip">список</span>
                <span v-if="item.type == 2  && (item.poomsae_type == 1 || item.poomsae_type == 2)" class="adm-chip">{{item.type == 2 && item.poomsae_type == 1 ? 'традиційне':''}}{{item.type == 2 && item.poomsae_type == 2 ? 'вільне':''}}</span>
              </div>
            </td>

            <td>{{item.age_category}}</td>

            <td class="nowrap"><span v-if="item.sex == 1">чоловік</span><span v-if="item.sex == 2">жінка</span></td>
            <td class="col-count"><span class="ct-count" :class="{zero: !(item.count > 0)}">{{item.count || 0}}</span></td>
            <td class="nowrap">
              <div class="ct-docs">
                <button type="button" class="adm-btn adm-btn-sm" @click="downloadPdf(item, 'results')" title="Завантажити жеребкування (PDF)">
                  <tkd-icon name="file"/> Жеребкування
                </button>
                <button type="button" class="adm-btn adm-btn-sm" @click="downloadPdf(item, 'weight')" title="Завантажити протокол зважування (PDF)">
                  <tkd-icon name="scale"/> Зважування
                </button>
              </div>
            </td>
            <td class="col-actions">
              <div class="ct-actions">
                <button type="button" class="adm-icon-btn" @click="updateOneCategory(item)" title="Редагувати" aria-label="Редагувати"><tkd-icon name="edit"/></button>
                <button type="button" class="adm-icon-btn danger" @click="deleteOneCategory(item.id)" title="Видалити" aria-label="Видалити"><tkd-icon name="trash"/></button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <!--                TODO Додати перевiрку на JS при створенні-редагуванні-->
    </section>

    <section class="adm-empty" v-else>
      <div class="adm-empty-icon" aria-hidden="true"><tkd-icon name="section"/></div>
      <template v-if="hasActiveFilters">
        <p>За вибраними фільтрами категорій не знайдено</p>
        <button type="button" class="adm-btn" @click="resetFilters()">Скинути фільтри</button>
      </template>
      <template v-else>
        <p>Інформація відсутня</p>
        <button type="button" class="adm-btn adm-btn-primary" @click="toogleAddCategory()"><span aria-hidden="true"><tkd-icon name="plus"/></span> Додати категорію</button>
      </template>
    </section>

  </div>
</template>

<script>
import axios from 'axios';
import 'src/assets/css/tkd-theme.css';
import 'src/assets/css/tkd-admin.css';

  import {Sortable, Plugins, DragStartEvent, DragStopEvent} from '@shopify/draggable';
  import FormCategory from  'src/pages/tournament/_formCategory.vue';
  import TournamentCategoryList from 'src/components/TournamentCategoryList.vue';
  import {baseUrlServer} from "../../api/user";
  export default {
    name: "tab-categories",
    components:{
      'form-category': FormCategory,
      'tournament-category-list': TournamentCategoryList,
    },

    data: function(){

      return {
        selectedCategoryId: 0,
        searchQuery: '',
        filterClassVal: null,
        filterPoomsaeTypeVal: null,
        // локальний фільтр: all / filled / empty
        filterFill: 'all',
        // sortableCategoyDay:'',
        formCategoryData:{
          id:'',
          name:'',
          age1:'',
          age2:'',
          sex:'',
          type:'',
          weight1:'',
          weight2:'',
          poomsaeType:'',
          showType:'',
          agecategory:'',
          section:'',
          categoryStatus:'',
        },
      }
    },


    computed: {
      activeTab() {
        return this.$store.getters['settings/activeTournamentTab'];
      },
      filterClassOptions() {
        const classOptions = [];

        if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.protocols) {
          return [];
        }

        this.tournamentOne.data.item.protocols.forEach(protocol => {
          const categoryClass = this.extractCategoryClass(protocol);
          if (categoryClass && !classOptions.includes(categoryClass)) {
            classOptions.push(categoryClass);
          }
        });

        return classOptions.map(option => ({ name: option, value: option }));
      },
      filterPoomsaeTypeOptions() {
        const typeOptions = [];

        if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.protocols) {
          return [];
        }

        this.tournamentOne.data.item.protocols.forEach(protocol => {
          const poomsaeType = this.extractPoomsaeType(protocol);
          if (poomsaeType && !typeOptions.find(option => option.value === poomsaeType.value)) {
            typeOptions.push(poomsaeType);
          }
        });

        return typeOptions;
      },
      actionTournamentAddCategory() {
        return this.$store.getters['settings/actionTournamentAddCategory'];
      },

      activeTournamentCategoryTab() {
        return this.$store.getters['settings/activeTournamentCategoryTab'];
      },

      tournamentOne() {
        return this.$store.getters['tournament/tournamentOne'];
      },

      allProtocols() {
        if (this.tournamentOne.data && this.tournamentOne.data.item && this.tournamentOne.data.item.protocols) {
          return this.tournamentOne.data.item.protocols;
        }
        return [];
      },


      totalSportsmans() {
        return this.allProtocols.reduce((sum, item) => sum + (Number(item.count) || 0), 0);
      },
      emptyCount() {
        return this.allProtocols.filter(item => !(item.count > 0)).length;
      },
      fillTabs() {
        const list = this.filteredCategories;
        const empty = list.filter(item => !(item.count > 0)).length;
        return [
          {id: 'all', label: 'Всі', count: list.length},
          {id: 'filled', label: 'З учасниками', count: list.length - empty},
          {id: 'empty', label: 'Порожні', count: empty},
        ];
      },
      // filteredCategories + фільтр наповненості
      visibleCategories() {
        if (this.filterFill === 'filled') return this.filteredCategories.filter(item => item.count > 0);
        if (this.filterFill === 'empty') return this.filteredCategories.filter(item => !(item.count > 0));
        return this.filteredCategories;
      },
      hasActiveFilters() {
        return !!((this.searchQuery && this.searchQuery.trim()) || this.filterClassVal || this.filterPoomsaeTypeVal || this.filterFill !== 'all');
      },

      filteredCategories: function() {

        function compare( a, b ) {
          if ( a.count < b.count ){
            return -1;
          }
          if ( a.count > b.count ){
            return 1;
          }
          return 0;
        }




        console.log('filteredCategories', this.tournamentOne.data?.item?.protocols);
        let filters = [];
        if(this.tournamentOne.data && this.tournamentOne.data.item && this.tournamentOne.data.item.protocols){
          filters = this.tournamentOne.data.item.protocols;
          // let checkedFiters = this.tournamentOne.data.item.protocols.filter(function(el) {
          //   return el.count > 0;
          // });
          // checkedFiters.forEach(element => {
          //   filters.push(element);
          // });


        }
        if (this.searchQuery && this.searchQuery.trim()) {
          const searchQuery = this.searchQuery.trim().toLowerCase();
          filters = filters.filter(item => this.getCategorySearchText(item).includes(searchQuery));
        }

        if (this.filterClassVal) {
          filters = filters.filter(item => this.extractCategoryClass(item) === this.filterClassVal.value);
        }

        if (this.filterPoomsaeTypeVal) {
          filters = filters.filter(item => {
            const poomsaeType = this.extractPoomsaeType(item);
            return poomsaeType && poomsaeType.value === this.filterPoomsaeTypeVal.value;
          });
        }

        return filters;
      },
    },


    mounted(){
      // this.setSortableCategoryDay();
    },
    updated(){
      // this.setSortableCategoryDay();
    },
    created() {
      this.baseUrlServer = baseUrlServer;
    },

    methods:{
      resetFilters() {
        this.searchQuery = '';
        this.filterClassVal = null;
        this.filterPoomsaeTypeVal = null;
        this.filterFill = 'all';
      },
      getCategorySearchText(category) {
        const fullName = category?.fullname || category?.name || '';
        const sexLabel = String(category?.sex) === '1'
          ? 'чоловік'
          : (String(category?.sex) === '2' ? 'жінка' : '');
        const typeLabel = String(category?.type) === '1'
          ? 'керугі'
          : (String(category?.type) === '2' ? 'пумсе' : '');
        const showTypeLabel = String(category?.show_type) === '1'
          ? 'сітка'
          : (String(category?.show_type) === '2' ? 'список' : '');
        const classLabel = this.extractCategoryClass(category) || '';
        const poomsaeType = this.extractPoomsaeType(category);

        return [
          fullName,
          category?.age_category || '',
          sexLabel,
          typeLabel,
          showTypeLabel,
          classLabel,
          poomsaeType ? poomsaeType.name : '',
          category?.id || '',
          category?.count || ''
        ].join(' ').toLowerCase();
      },
      extractCategoryClass(category) {
        const fullName = category?.fullname || category?.name || '';
        const match = fullName.match(/^Клас\s+([АБС])/i);
        return match ? match[1].toUpperCase() : null;
      },
      extractPoomsaeType(category) {
        const fullName = category?.fullname || category?.name || '';
        if (fullName.includes('Традиційні пумсе')) {
          return { name: 'Традиційні', value: 'traditional' };
        }
        if (fullName.includes('Вільні пумсе')) {
          return { name: 'Вільні', value: 'freestyle' };
        }
        return null;
      },

      // удаление одной категории с турнира
      updateOneCategory(category){
          this.selectedCategoryId = category.id;
          console.log(category);

          // this.formAddSportsman.first_name = sportsman.first_name;
          this.formCategoryData.id = category.id;
          this.formCategoryData.name = category.fullname;
          this.formCategoryData.age1 = category.age1;
          this.formCategoryData.age2 = category.age2;
          this.formCategoryData.sex = category.sex;
          this.formCategoryData.type = category.type;
          this.formCategoryData.weight1 = category.weight1;
          this.formCategoryData.weight2 = category.weight2;
          this.formCategoryData.poomsaeType = category.poomsaeType;
          this.formCategoryData.categoryStatus = category.categoryStatus;
          this.formCategoryData.showType = category.showType;
          this.formCategoryData.agecategory = category.age_category;

        if(category.show_type == '1'){
          this.formCategoryData.showType =  {id:1, name:'Сітка'};
        }else if(category.show_type == '2'){
          this.formCategoryData.showType = {id:2, name:'Список'};
        }

        if(category.type == '1'){
          this.formCategoryData.type =  {id:1, name:'Керугі'};
        }else if(category.type == '2'){
          this.formCategoryData.type = {id:2, name:'Пумсе'};
        }

        if(category.poomsae_type == 0){
          this.formCategoryData.poomsaeType = {id:0, name:'-'};
        }
        else if(category.poomsae_type == '1'){
          this.formCategoryData.poomsaeType =   {id:1, name:'Традиційне'};
        }else if(category.poomsae_type == '2'){
          this.formCategoryData.poomsaeType = {id:2, name:'Вільне (фрістайл)'};
        }

        if(category.category_status == 0){
          this.formCategoryData.categoryStatus = {id:0, name:'-'};
        }
        else if(category.category_status == '1'){
          this.formCategoryData.categoryStatus =   {id:1, name:'Опубліковано'};
        }else if(category.category_status == '2'){
          this.formCategoryData.categoryStatus = {id:2, name:'Чернетка'};
        }



        if(category.sex == 0){
          this.formCategoryData.sex = {id:0, name:'-'};
        }else if(category.sex == '1'){
          this.formCategoryData.sex =  {id:1, name:'чоловік'};
        }else if(category.sex == '2'){
          this.formCategoryData.sex = {id:2, name:'жінка'};
        }

        this.$store.dispatch('settings/setActionTournamentAddCategory',true);
        this.$modal.show('category-form-modal');
      },

      deleteOneCategory(id){

        if (window.confirm(" Після видалення дані неможливо буде відновити. Ви впевнені, що хочете видали категорію з турніру?")) {
          let params = {'id': id};
          this.$store.dispatch('tournament/deleteOneCategory', params)
            .then(() => this.deleteFromListCategory(id));
        }
      },
      deleteFromListCategory(id){
        // Check if protocols exists
        if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.protocols) {
          return;
        }

        let length = this.tournamentOne.data.item.protocols.length;
        for (let i = 0; i < length; i++) {
          console.log(this.tournamentOne.data.item.protocols[i].id);
          if (this.tournamentOne.data.item.protocols[i].id === id){
            this.tournamentOne.data.item.protocols.splice(i, 1);
            break;
          }
        }
      },






      toogleAddCategory(){
        // if(this.actionTournamentAddCategory == true){
        //   this.$store.dispatch('settings/setActionTournamentAddCategory',false);
        // }else{
        //   this.$store.dispatch('settings/setActionTournamentAddCategory',true);
        // }
        // Reset Category Form
        this.formCategoryData.id = '';

        this.$store.dispatch('settings/setActionTournamentAddCategory',true);
        this.$modal.show('category-form-modal');
      },

      showCategoryForm () {
        this.$modal.show('category-form-modal');
      },
      hideCategoryForm () {
        this.$modal.hide('category-form-modal');
      },


      setActiveCategoryTab(position){
        this.$store.dispatch('settings/setActiveTournamentCategoryTab', position);
      },

      resortCategoryDays(){
        let day1 = document.getElementById('day1');
        let day2 = document.getElementById('day2');
        let itemsDay1 = day1.getElementsByClassName('category-item');
        let itemsDay2 = day2.getElementsByClassName('category-item');

        let categoryId = '';
        let day1ids = [];
        let day1position = [];
        let day2ids = [];
        let day2position = [];


        let i = 0;
        for (i = 0; i<itemsDay1.length; i++){
          if(itemsDay1[i] == undefined){
            continue;

          }
          if(itemsDay1[i].classList.contains('draggable-mirror')){

          }else if(itemsDay1[i].classList.contains('draggable-mirror')){

          }else if(itemsDay1[i].classList.contains('draggable--original')){

          }else{

            console.log(itemsDay1[i]);
            categoryId = itemsDay1[i].getAttribute('data-category-id');

            day1ids.push(categoryId);
            day1position.push({id:categoryId, position:i})
          }

        }

        i++;
        for (let k = 0; k<itemsDay2.length; k++){
          if(itemsDay2[i] == undefined){
            continue;

          }
          if(itemsDay2[i].classList.contains('draggable-mirror')){

          }else if(itemsDay2[k].classList.contains('draggable-mirror')){

          }else if(itemsDay2[k].classList.contains('draggable--original')){

          }else{
            categoryId = itemsDay2[k].getAttribute('data-category-id');
            day2ids.push(categoryId);
            day2position.push({id:categoryId, position:(k+i)})
          }

        }


        console.log('itemsDay1', itemsDay1);

        let params = {
          day1ids:day1ids,
          day2ids:day2ids,
          day1position:day1position,
          day2position:day2position,
        };
        console.log('params', params);
        this.$store.dispatch('tournament/setCategoryDays', params)
        // .then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.id}))
          .catch(error => {
            alert('Помилка сервера');
          });
      },

      downloadPdf(category, type){
        var url = baseUrlServer+'/tournament-result/print-pdf?category='+category.id;
        var nameFile = category.fullname.replace(/\s+/g,"_");
        if(type == 'weight'){
          nameFile = 'Протокол_Зважування_'+nameFile;
          url = baseUrlServer+'/tournament-report/print-weight-pdf?category='+category.id;
        }

        axios({
          url: url,
          method: 'GET',
          responseType: 'blob',
        }).then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');

          fileLink.href = fileURL;

          fileLink.setAttribute('download', nameFile+'.pdf');
          document.body.appendChild(fileLink);

          fileLink.click();
        });
      }


    }
  }
</script>

<style scoped>
.category-card-meta {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 8px;
}

.category-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.category-card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 6px;
}

.category-card-actions:last-child {
  margin-bottom: 0;
}

.tab-categories {
  /* перекриває .tournament-content-tab { background:#fff } з _custom.scss */
  background: transparent;
  font-family: var(--tkd-font);
  color: var(--tkd-text);
}

.ct-head-stats { display: flex; flex-wrap: wrap; gap: 8px; margin-right: auto; }

.ct-filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
}

.col-num, .col-id { width: 1%; white-space: nowrap; font-size: 12px; color: var(--tkd-muted); font-variant-numeric: tabular-nums; }
.col-name { min-width: 220px; }
.col-count { width: 1%; text-align: center; }
.col-actions { width: 1%; text-align: right; white-space: nowrap; }
.nowrap { white-space: nowrap; }

.ct-name { font-weight: 700; }
.ct-tags { display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px; }

.ct-count {
  display: inline-block;
  min-width: 32px;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--tkd-navy);
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  font-variant-numeric: tabular-nums;
}

.ct-count.zero { background: var(--tkd-bg); border: 1px solid var(--tkd-border); color: var(--tkd-muted); }

.empty-category .ct-name { color: var(--tkd-muted); }

.ct-docs, .ct-actions { display: inline-flex; gap: 8px; }
.ct-actions { gap: 10px; }

</style>
